(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-injector"] && !Shopify.designMode) return;
  try {
    
(function() {
  function log(){ if (window && window.console) console.log.apply(console, ['[image-injector]'].concat([].slice.call(arguments))); }
  function warn(){ if (window && window.console) console.warn.apply(console, ['[image-injector]'].concat([].slice.call(arguments))); }
  function normalizeId(val){ return val ? String(val).trim().replace(/^#/,'') : ''; }
  function isDesignMode(){ return !!(window.Shopify && Shopify.designMode); }

  var schedule = (function(){ var t=null; return function(fn){ clearTimeout(t); t=setTimeout(fn,50); }; })();
  var injectorObservers = new WeakMap();   // ResizeObserver per host/reference
  var overlayStickyMap  = new WeakMap();   // gestori scroll per sticky overlay

  function anchorTranslate(anchor){
    switch(anchor){
      case 'top-left': return 'translate(0%, 0%)';
      case 'top-center': return 'translate(-50%, 0%)';
      case 'top-right': return 'translate(-100%, 0%)';
      case 'center-left': return 'translate(0%, -50%)';
      case 'center': return 'translate(-50%, -50%)';
      case 'center-right': return 'translate(-100%, -50%)';
      case 'bottom-left': return 'translate(0%, -100%)';
      case 'bottom-center': return 'translate(-50%, -100%)';
      case 'bottom-right': return 'translate(-100%, -100%)';
      default: return 'translate(-50%, -50%)';
    }
  }

  function resolveReferenceBox(host, imgEl){
    var sel = imgEl.getAttribute('data-ref-selector');
    if (sel) { try { var node = host.querySelector(sel); if (node) return node; } catch(e) {} }
    var candidates = ['.page-width', '.container', '.content-for-layout', '.section__content', '.wrapper'];
    for (var i=0;i<candidates.length;i++){ var n = host.querySelector(candidates[i]); if (n) return n; }
    return host;
  }

  function applyContentRelativePosition(host, imgEl){
    if (!host || !imgEl) return;
    var x = parseFloat(imgEl.getAttribute('data-pos-x')) || 50;
    var y = parseFloat(imgEl.getAttribute('data-pos-y')) || 50;
    var ox = parseFloat(imgEl.getAttribute('data-offset-x')) || 0;
    var oy = parseFloat(imgEl.getAttribute('data-offset-y')) || 0;
    var anchor = imgEl.getAttribute('data-anchor-point') || 'center';

    var cs = window.getComputedStyle(host);
    if (!cs.position || cs.position === 'static') host.style.position = 'relative';

    var ref = resolveReferenceBox(host, imgEl);
    var hostRect = host.getBoundingClientRect();
    var refRect  = ref.getBoundingClientRect();

    var baseLeft = refRect.left - hostRect.left;
    var baseTop  = refRect.top  - hostRect.top;

    var leftPx = Math.round(baseLeft + (refRect.width  * (x/100)) + ox);
    var topPx  = Math.round(baseTop  + (refRect.height * (y/100)) + oy);

    imgEl.style.left = leftPx + 'px';
    imgEl.style.top  = topPx  + 'px';

    var baseTransform = anchorTranslate(anchor);
    imgEl.style.transform = baseTransform;
    imgEl.dataset.injBaseTransform = baseTransform; // salva base per sticky overlay

    return { leftPx: leftPx, topPx: topPx };
  }

  function applyStickyStart(host, imgEl){
    var xy = applyContentRelativePosition(host, imgEl) || {leftPx:0, topPx:0};
    var base = imgEl.dataset.injBaseTransform || 'translate(-50%,-50%)';
    imgEl.style.setProperty('--inj-left', xy.leftPx + 'px');
    imgEl.style.setProperty('--inj-top',  xy.topPx  + 'px');
    imgEl.style.setProperty('--inj-transform', base);
  }

  function applyStickyOverlay(host, imgEl){
    var pos = applyContentRelativePosition(host, imgEl) || {leftPx:0, topPx:0};
    var topOffset = parseFloat(imgEl.getAttribute('data-sticky-top-offset')) || 0;

    if (overlayStickyMap.has(imgEl)) return;

    var onScroll = function(){
      var hostRect = host.getBoundingClientRect();
      var startInHost = pos.topPx; // punto di partenza verticale dentro host
      var startViewportY = hostRect.top + startInHost;

      var delta = topOffset - startViewportY; // quanto serve per “attaccare” al topOffset
      var imgH = imgEl.offsetHeight;
      var maxTranslate = hostRect.height - startInHost - imgH;
      if (maxTranslate < 0) maxTranslate = 0;

      var translateY = 0;
      if (delta > 0) translateY = Math.min(delta, maxTranslate);

      var base = imgEl.dataset.injBaseTransform || 'translate(-50%,-50%)';
      imgEl.style.transform = base + ' translateY(' + translateY + 'px)';
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    overlayStickyMap.set(imgEl, onScroll);

    // ricalcolo quando host/reference cambiano dimensioni
    ensureObserver(host, imgEl, 'abs', function(){
      pos = applyContentRelativePosition(host, imgEl) || pos; // aggiorna base e baseTransform
      onScroll();
    });
  }

  // Observer generico per ricalcoli; extraCb è opzionale
  function ensureObserver(host, imgEl, mode, extraCb){
    if (injectorObservers.has(host)) return;
    try {
      var ro = new ResizeObserver(function(){
        if (mode === 'sticky-native') applyStickyStart(host, imgEl);
        else applyContentRelativePosition(host, imgEl);
        if (typeof extraCb === 'function') extraCb();
      });
      ro.observe(host);
      var ref = resolveReferenceBox(host, imgEl);
      if (ref && ref !== host) ro.observe(ref);
      injectorObservers.set(host, ro);
    } catch(e) {
      window.addEventListener('resize', function(){
        if (mode === 'sticky-native') applyStickyStart(host, imgEl);
        else applyContentRelativePosition(host, imgEl);
        if (typeof extraCb === 'function') extraCb();
      });
    }
  }

  function injectOnce(host, imgEl){
    if (!host || !imgEl) return;

    var key = imgEl.getAttribute('data-injector-key') || '';
    var pos = imgEl.getAttribute('data-position');
    var position = (pos === 'afterbegin' || pos === 'beforeend' || pos === 'beforebegin' || pos === 'afterend') ? pos : 'beforeend';
    var forceRel = imgEl.getAttribute('data-force-relative');
    var isStickyNative  = imgEl.getAttribute('data-sticky') === 'true' || imgEl.getAttribute('data-sticky') === '1';
    var isStickyOverlay = imgEl.getAttribute('data-sticky-overlay') === 'true' || imgEl.getAttribute('data-sticky-overlay') === '1';

    if (forceRel === 'true' || forceRel === '1') {
      try {
        var cs = window.getComputedStyle(host);
        if (!cs.position || cs.position === 'static') host.style.position = 'relative';
      } catch(e) {}
    }

    if (imgEl.style && imgEl.style.display === 'none') imgEl.style.display = '';

    var existing = key ? host.querySelector('img[data-injector-key="'+ key +'"]') : null;

    if (key) {
      var dups = document.querySelectorAll('img[data-injector-key="'+ key +'"]');
      for (var i = 0; i < dups.length; i++) {
        if (dups[i] !== imgEl && dups[i] !== existing) { dups[i].parentNode && dups[i].parentNode.removeChild(dups[i]); }
      }
    }

    imgEl.onerror = function(){ warn('Errore caricamento immagine', imgEl.src); };
    imgEl.onload  = function(){ log('Immagine caricata', imgEl.src); };

    function afterInsert(){
      if (isStickyOverlay) {
        applyStickyOverlay(host, imgEl);
      } else if (isStickyNative) {
        applyStickyStart(host, imgEl);
        ensureObserver(host, imgEl, 'sticky-native');
      } else {
        applyContentRelativePosition(host, imgEl);
        ensureObserver(host, imgEl, 'abs');
      }
    }

    try {
      if (existing) {
        existing.replaceWith(imgEl);
        afterInsert();
        log('Sostituita immagine esistente in', host.id || host.tagName);
      } else {
        host.insertAdjacentElement(position, imgEl);
        afterInsert();
        log('Iniettata immagine in', host.id || host.tagName, 'posizione:', position);
      }
    } catch (err) {
      try {
        if (existing && existing.parentNode) { existing.parentNode.replaceChild(imgEl, existing); }
        else { host.appendChild(imgEl); }
        afterInsert();
        log('Fallback inserimento su', host.id || host.tagName);
      } catch(e) { warn('Inserimento fallito su host', host, e); }
    }
  }

  function processSection(root){
    var store = root.querySelector('.image-injector-store');
    if (!store) { warn('Store non trovato'); return; }
    var images = store.querySelectorAll('img[data-target-id]');
    if (!images.length) { warn('Nessuna immagine configurata'); return; }

    var pending = [];
    for (var i = 0; i < images.length; i++) {
      var imgEl = images[i];
      var id = normalizeId(imgEl.getAttribute('data-target-id'));
      var host = document.getElementById(id);
      if (host) injectOnce(host, imgEl);
      else { pending.push(imgEl); warn('Target non trovato per', id); }
    }

    if (pending.length) {
      var maxTries = 100, tries = 0;
      var interval = setInterval(function(){
        if (!pending.length || ++tries >= maxTries) { clearInterval(interval); return; }
        var still = [];
        for (var j = 0; j < pending.length; j++) {
          var el = pending[j];
          var id = normalizeId(el.getAttribute('data-target-id'));
          var host = document.getElementById(id);
          if (host) injectOnce(host, el); else still.push(el);
        }
        pending = still;
      }, 100);

      var obs = new MutationObserver(function(){
        if (!pending.length) { obs.disconnect(); return; }
        var still = [];
        for (var k = 0; k < pending.length; k++) {
          var el = pending[k];
          var id = normalizeId(el.getAttribute('data-target-id'));
          var host = document.getElementById(id);
          if (host) injectOnce(host, el); else still.push(el);
        }
        pending = still;
        if (!pending.length) obs.disconnect();
      });
      try { obs.observe(document.documentElement, { childList: true, subtree: true }); } catch(e) {}
    }
  }

  function boot(){
    var sections = document.querySelectorAll('section.image-injector');
    if (!sections.length) { warn('Sezione image-injector non trovata nel DOM'); return; }
    for (var i = 0; i < sections.length; i++) processSection(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  // Theme Editor: debounce e cleanup
  document.addEventListener('shopify:section:load', function(e){
    if (!isDesignMode()) return;
    var root = (e && e.target) ? e.target : null;
    schedule(function(){
      if (!root) return;
      var sec = root.matches && root.matches('section.image-injector') ? root : (root.querySelector && root.querySelector('section.image-injector'));
      if (sec) processSection(sec);
    });
  });

  document.addEventListener('shopify:section:unload', function(e){
    if (!isDesignMode()) return;
    var root = e && e.target ? e.target : null;
    if (!root) return;
    var sec = root.matches && root.matches('section.image-injector') ? root : (root.querySelector && root.querySelector('section.image-injector'));
    if (!sec) return;
    var sid = sec.getAttribute('data-section-id') || '';
    if (!sid) return;
    var imgs = document.querySelectorAll('img[data-injector-key^="'+ sid +'-"]');
    for (var i=0;i<imgs.length;i++){ if (imgs[i].parentNode) imgs[i].parentNode.removeChild(imgs[i]); }

    // rimuovi handler sticky overlay
    overlayStickyMap.forEach(function(handler, el){
      window.removeEventListener('scroll', handler);
      window.removeEventListener('resize', handler);
    });
    overlayStickyMap = new WeakMap();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
